"use client";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import isEmpty from "lodash/isEmpty";

import { fetchStadiumLoggedOutNav } from "@sendmagic/prismic-nextjs/src/apis/prismic";

import { PRISMIC_APP_NAME_NEW_NAV } from "@stadium/shared/src/constants/prismic";

import defaultStyles from "./main.module.scss";

const HeaderLinks = dynamic(() =>
  import(
    /* webpackChunkName: "PriHeaderLinksCustomType" */ "@sendmagic/prismic-nextjs/src/components/header/Links"
  ),
);

const defaultObj = {};

const PrismicHeaderLinks = ({ styles = defaultStyles, isMarketingPage = false } = defaultObj) => {


  const [prismicDoc, setPrismicDoc] = useState(defaultObj);
  useEffect(() => {
    fetchStadiumLoggedOutNav(PRISMIC_APP_NAME_NEW_NAV).then((doc) => setPrismicDoc(doc));
  }, []);

  if (isEmpty(prismicDoc)) return null;

  return (
    <HeaderLinks
      doc={prismicDoc?.data}
      styles={styles}
      dropdownType="click"
      isMarketingPage={isMarketingPage}
    />
  );
};

export default PrismicHeaderLinks;
